import React from "react"
import type { Dispatch } from "react"
import { ComparativoUnidadesInicial } from "../models/comparativoUnidadesModel"
import type { ComparativoUnidadesModel } from "../models/comparativoUnidadesModel"
import type { ComparativoUnidadesAction } from "./comparativoUnidadesActions"

interface ComparativoUnidadesContextType {
    dados: ComparativoUnidadesModel
    dispatch: Dispatch<ComparativoUnidadesAction>
    erroCarregamento: string | null
    pesquisar: (dataInicio: string, dataFim: string) => Promise<void>
}

export const ComparativoUnidadesContext = React.createContext<ComparativoUnidadesContextType>({
    dados: ComparativoUnidadesInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    pesquisar: async () => undefined,
})
